import Proxy from '../Proxy';

class IncomesProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('incomes', parameters);
  }
}

export default IncomesProxy;
